import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AppBreadcrumbService } from 'src/app/app.breadcrumb.service';
import { Contacto } from 'src/app/models/notificacion/contacto.model';
import { ProcesoReporte } from 'src/app/pages/base/proceso-reporte';
import { ContactoService } from 'src/app/services/notificacion/contacto.service';
import { XlsxService } from 'src/app/services/utils/xlsx.service';

@Component({
  selector: 'app-importar-contacto',
  templateUrl: './importar-contacto.component.html',
  styleUrls: ['./importar-contacto.component.scss']
})
export class ImportarContactoComponent extends ProcesoReporte implements OnInit {

    uploadedFiles:  Record<string, any>[];
    archivoCargado: boolean = false
    error: number;
    msg_error: string = '';
    creados: number;
    actualizados: number;
    constructor(
        public messageService: MessageService,
        private xlsService: XlsxService,
        public service: ContactoService,
        private fb: FormBuilder,
        private confirmationService: ConfirmationService,
        private breadcrumbService: AppBreadcrumbService,
    ) {
        super();
        this.breadcrumbService.setItems([{ label: 'Notificacion' }, { label: 'Importar Contactos' }]);
        this.creados = 0;
        this.actualizados = 0;
        this.recordName = Contacto.RECORD_NAME;
    }

    ngOnInit(): void {
        this.crearFormulario();

    }

    async crearFormulario() {
        this.formGroup = this.fb.group({
            id_empresa: [this.currentUser.id_empresa],
            nombre_empresa: [this.currentUser.nombre_empresa],
        });
    }

    async cargarArchivo( event: any ) {
        for (const file of event.files) {
            this.uploadedFiles.push(file);
        }
    }

    
    async ventanaConfirmar(): Promise<boolean>  {
        return new Promise<boolean>((resolve) => {
            this.confirmationService.confirm({
                // target: event.target as EventTarget,
                message: `Se crearan los siguientes  Contactos. Seguro/a que desea continuar?`,
                header: `Confirmar `,
                icon: 'pi pi-exclamation-triangle',
                // acceptIcon:"none",
                // rejectIcon:"none",
                rejectButtonStyleClass:"p-button-text",
                accept: () => {
                    resolve(true);
                },
                reject: () => {
                    resolve(false);
                }
            });
        })
    }

    

    async procesarArchivo( event: any ) {
        try {
            const value = this.formGroup.value;
            const resp = await this.ventanaConfirmar();
            if ( !resp ) {
                this.messageService.add({ severity: 'error', summary: 'Cancelado', detail: '', life: 3000 });
                this.loading = false;
                return;
            }
            this.loading = true;
            const file = event.files[0];
            const formData = new FormData();
            formData.append('archivo', file);
            
            const filtros = JSON.stringify({...this.formGroup.value, 'id_usuario': this.currentUser.id });
            const sendResp = await this.service.procesarContactos( formData, filtros );
            if ( sendResp.ok ) {
                const resumen = sendResp.resp;
                this.creados = resumen.creados;
                this.actualizados = resumen.actualizados;
                this.error = resumen.error;
                this.msg_error = resumen.msg_error;
                this.messageService.add({severity: 'success', summary: 'Proceso Finalizado', detail: '' });
            } else {
                throw new Error( sendResp.msg )
            }
            this.loading = false;
        } catch (error: any) {
            this.loading = false;
            this.messageService.add({severity: 'error', summary: 'Error', detail: error.message });
        }
    }

    async onSelect( event: any ) {
        this.archivoCargado = true;
    
    }
    
    async onImport() {
        await this.xlsService.downloadDoc(this.recordName.split(".")[1]);
    }

}
